import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = [
    "idFields",
    "passportFields",
    "idInput",
    "passportInput",
    "genderDerivedFields",
    "genderManualFields",
    "gender",
    "manualGender",
    "nationality",
    "dob"
  ]

  connect() {
    this.toggle()
  }

  change(event) {
    if (event) event.preventDefault()
    this.clearFields()
    this.toggle()
  }

  toggle() {
    const passport = this.selectedType() === "passport"
    this.showTarget(this.idFieldsTarget, !passport)
    this.showTarget(this.passportFieldsTarget, passport)
    this.toggleGenderFields(passport)

    if (this.hasIdInputTarget) {
      this.idInputTarget.disabled = passport
      this.idInputTarget.required = !passport
    }

    if (this.hasPassportInputTarget) {
      this.passportInputTarget.disabled = !passport
      this.passportInputTarget.required = passport
    }

    this.toggleManualFields(passport)
  }

  toggleGenderFields(passport) {
    if (this.hasGenderDerivedFieldsTarget) {
      this.showTarget(this.genderDerivedFieldsTarget, !passport)
    }
    if (this.hasGenderManualFieldsTarget) {
      this.showTarget(this.genderManualFieldsTarget, passport)
    }

    if (this.hasGenderTarget) {
      this.genderTarget.readOnly = true
      this.genderTarget.required = false
      this.genderTarget.disabled = passport
      if (passport) this.genderTarget.value = ""
      this.genderTarget.classList.toggle("bg-slate-50", true)
    }

    if (this.hasManualGenderTarget) {
      this.manualGenderTarget.disabled = !passport
      this.manualGenderTarget.required = passport
      if (!passport) this.manualGenderTarget.value = ""
    }
  }

  toggleManualFields(enable) {
    if (this.hasNationalityTarget) {
      this.nationalityTarget.readOnly = !enable
      this.nationalityTarget.required = enable
      this.nationalityTarget.classList.toggle("bg-slate-50", !enable)
    }
    if (this.hasDobTarget) {
      this.dobTarget.readOnly = !enable
      this.dobTarget.required = enable
      this.dobTarget.classList.toggle("bg-slate-50", !enable)
    }
  }

  selectedType() {
    const checked = this.element.querySelector("input[name$='[identity_document_type]']:checked")
    return checked ? checked.value : "sa_id"
  }

  showTarget(target, visible) {
    if (!target) return
    target.classList.toggle("hidden", !visible)
  }

  clearFields() {
    if (this.hasIdInputTarget) this.idInputTarget.value = ""
    if (this.hasPassportInputTarget) this.passportInputTarget.value = ""
    if (this.hasGenderTarget) this.genderTarget.value = ""
    if (this.hasManualGenderTarget) this.manualGenderTarget.value = ""
    if (this.hasNationalityTarget) this.nationalityTarget.value = ""
    if (this.hasDobTarget) this.dobTarget.value = ""
  }
}
